import React, { useState, useEffect } from 'react';
const SPARKS = Array.from({ length: 20 }, (_, i) => {
  const a = (i / 20) * 360, d = 70 + Math.random() * 60;
  return { tx: `${Math.cos(a*Math.PI/180)*d}px`, ty: `${Math.sin(a*Math.PI/180)*d}px`, d: `${0.6+Math.random()*0.6}s` };
});
const RINGS = [0,1,2].map((_,i) => ({ delay: `${0.8 + i*0.3}s` }));

export default function SplashScreen({ onComplete }) {
  const [out, setOut] = useState(false);
  useEffect(() => { const t = setTimeout(() => { setOut(true); setTimeout(() => onComplete?.(), 1000); }, 3500); return () => clearTimeout(t); }, [onComplete]);
  return (
    <div className={`splash ${out ? 'out' : ''}`}>
      <div className="splash-glow" />
      <div style={{ position: 'relative' }}>
        <div className="splash-rings">
          {RINGS.map((r, i) => <div key={i} className="splash-ring" style={{ animationDelay: r.delay }} />)}
        </div>
        <div className="splash-sparks">
          {SPARKS.map((s, i) => <div key={i} className="spark" style={{ '--tx': s.tx, '--ty': s.ty, '--d': s.d, animationDelay: s.d }} />)}
        </div>
        <div className="splash-coin"><img src="/coin.png" alt="RF" /></div>
      </div>
      <div className="splash-title">RICH FACTORY</div>
      <div className="splash-sub">CRYPTO PASSIVE INCOME</div>
      <div className="splash-bar"><div className="splash-bar-fill" /></div>
    </div>
  );
}
